import { Component, OnInit } from '@angular/core';
import { CleanersService } from '../../../injections/cleaners.service';
import { CleanerService } from '../../../injections/cleaner.service';
import {Router} from "@angular/router";

@Component({
    moduleId: module.id,
    selector: 'main-cleaners',
    templateUrl: '../templates/main-cleaners.html',
    providers: [],
})

export class MainCleanersComponent implements OnInit {

    public cleaners: Array<number> = [];
    constructor(
        private cleanersService: CleanersService, 
        private _router: Router,
    ) 
    {}

    public goToCleaner(value: object) {
        this._router.navigate(['/cleaners', value["element"]["id"]]);
    }

    public createCleaner(object: object) {
        this.cleanersService.createCleaner(object).subscribe(response => {
            if(response["status"] == "OK"){
                this._router.navigate(['/cleaners', response["response"]["professionalId"]]);
            }
        });
    }

    public searchCleaners(object: object) {
        this.setTypeSearch(object);   
    }

    public setTypeSearch(search: object) {
        if(search["document"] != null) {
            this.cleanersService.findCleanerByDNI(search["document"]).subscribe(results => {
               if(Object.keys(results).length === 0) this.cleaners = [];
               else this.cleaners = results;
            });
        }else if(search["email"] != null){
             this.cleanersService.findCleanerByEmail(search["email"]).subscribe(results => {
                if(Object.keys(results).length === 0) this.cleaners = [];
                else this.cleaners = results;
            });
        }else if(search["phone"] != null){
             this.cleanersService.findCleanerByPhone(search["phone"]).subscribe(results => {
                if(Object.keys(results).length === 0) this.cleaners = [];
                else this.cleaners = results;
            });
        }
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/main-cleaners.component.ts